'use client';

import _slicedToArray from "/codebuild/output/src1629/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState } from 'react';
import { useIsomorphicEffect } from '@mantine/hooks';
var DirectionContext = createContext({
  dir: "ltr",
  toggleDirection: function toggleDirection() {},
  setDirection: function setDirection() {}
});
function useDirection() {
  return useContext(DirectionContext);
}
function DirectionProvider(_ref) {
  var children = _ref.children,
    _ref$initialDirection = _ref.initialDirection,
    initialDirection = _ref$initialDirection === void 0 ? "ltr" : _ref$initialDirection,
    _ref$detectDirection = _ref.detectDirection,
    detectDirection = _ref$detectDirection === void 0 ? true : _ref$detectDirection;
  var _useState = useState(initialDirection),
    _useState2 = _slicedToArray(_useState, 2),
    dir = _useState2[0],
    setDir = _useState2[1];
  var setDirection = function setDirection(direction) {
    setDir(direction);
    document.documentElement.setAttribute("dir", direction);
  };
  var toggleDirection = function toggleDirection() {
    return setDirection(dir === "ltr" ? "rtl" : "ltr");
  };
  useIsomorphicEffect(function () {
    if (detectDirection) {
      var direction = document.documentElement.getAttribute("dir");
      if (direction === "rtl" || direction === "ltr") {
        setDirection(direction);
      }
    }
  }, []);
  return /* @__PURE__ */jsx(DirectionContext.Provider, {
    value: {
      dir: dir,
      toggleDirection: toggleDirection,
      setDirection: setDirection
    },
    children: children
  });
}
export { DirectionContext, DirectionProvider, useDirection };